<template>
  <div class="equity_layout">
    <div class="equity_body">
      <div v-if="this.regionNo === '37'" class="equity_body_content">
        <!-- 顶级标题 -->
        <h1>山东惠享网购-权益业务说明</h1>
        <!-- 产品服务内容 -->
        <div class="equity_body_content_middle">
          <strong>产品服务内容:</strong>
          <p>本产品权益包含：天猫超市电子券、京东超市京东E卡、沃尔玛电子券、大润发电子券四项优惠券服务，用户每月可任选其一使用，次月可按需更换：</p>
          <ul>
            <li>
              <strong>天猫超市电子券：</strong>
              每月选用1次，2张10元天猫超市电子券，每隔7天可用领用1张，从领用第1张时间开始计算第2张30天领用有效期，过期无法领取。
              仅限天猫超市中网购使用；天猫、淘宝APP与电脑端天猫超市支持使用该电子券抵扣付款。
            </li>
            <li>
              <strong>京东超市京东E卡：</strong>
              每月选用1次，2张10元京东超市京东E卡，每隔7天可用领用1张，从领用第1张时间开始计算第2张30天领用有效期，过期无法领取。
              仅限京东商城APP、微信小程序移动端使用；在京东超市购物支付时支持使用该电子券抵扣付款。
            </li>
            <li>
              <strong>沃尔玛电子券：</strong>
              每月选用1次，2张10元沃尔玛电子券，每隔7天可用领用1张，从领用第1张时间开始计算第2张30天领用有效期，过期无法领取。
              在沃尔玛线上商城购买沃尔玛自营商品时，使用该电子券抵扣付款。
            </li>
            <li>
              <strong>大润发电子券：</strong>
              每月选用1次，2张10元大润发电子券，每隔7天可用领用1张，从领用第1张时间开始计算第2张30天领用有效期，过期无法领取。
              在大润发线上商城微信小程序、大润发优鲜应用购物支付时，支持使用该电子券抵扣付款。
            </li>
          </ul>
        </div>
        <!-- 注释内容 -->
        <div class="equity_body_content_footer">
          <p>
            注：以上天猫超市电子券、京东E卡、沃尔玛电子券、大润发电子券四大权益，每月可任选其一，
            确定使用本月的一项权益后，剩余的其它三项权益自动失效；下月可重新选择。
          </p>
        </div>
      </div>
      <div v-if="this.regionNo === '41'" class="equity_body_content">
        <!-- 顶级标题 -->
        <h1>河南惠享网购-权益业务说明</h1>
        <!-- 产品服务内容 -->
        <div class="equity_body_content_middle">
          <strong>产品服务内容:</strong>
          <p>
            本产品权益包含：中萃到家电子券、天猫超市电子券、京东超市京东E卡、三项优惠券服务（中萃到家电子券为必选券），其他两种，用户每月可任选其一使用，次月可按需更换：
          </p>
          <ul>
            <li>
              <strong>中萃到家电子券：</strong>
              每月领用激活1次，1张10元或20元超市电子券，仅限中萃到家小程序中网购使用；在中萃到家购物支付时，可使用中萃到家的金额抵扣付款。
            </li>
            <li>
              <strong>天猫超市电子券：</strong>
              每月选用1-2张10元天猫超市电子券（根据资费确认次数）。仅限天猫超市中网购使用；天猫、淘宝APP与电脑端天猫超市支持使用该电子券抵扣付款。
            </li>
            <li>
              <strong>京东超市京东E卡：</strong>
              每月选用1-2张10元京东E卡电子券（根据资费确认次数）。仅限京东商城APP/小程序移动端网购使用；在京东购物支付时，可使用京东E卡的金额抵扣付款。
            </li>
          </ul>
        </div>

        <!-- 注释内容 -->
        <div class="equity_body_content_footer">
          <p>
            注：以上中萃到家电子券、天猫超市电子券、京东E卡、三大权益（中萃到家电子券为必选券）外，另两种券每月可任选其一或其二，
            确定使用本月的一项权益后，剩余的其它一项权益自动失效；下月可重新选择。
          </p>
        </div>
      </div>
      <div  v-if="this.regionNo === '31'" class="equity_body_content">
        <div class="equity_body_content_top">
          <h1>上海惠享生活-权益业务说明</h1>
        </div>
        <div class="equity_body_content_middle">
          <p><strong>产品服务内容：</strong></p>
          <p>本产品权益包含：锅圈食汇电子券、叮咚买菜电子券、天猫超市电子券、京东超市京东E卡四项优惠券服务，用户每月可任选其一使用，次月可按需更换：</p>
          <ul>
            <li>
              <p><strong>锅圈食汇电子券：</strong></p>
              <p>每月选用 1 张 10 元锅圈食汇电子券，仅限于支持自取及外送的大陆地区锅圈食汇门店、“锅圈食汇”小程序支付时，可使用锅圈食汇电子券的金额抵扣付款。</p>
            </li>
            <li>
              <p><strong>叮咚买菜电子券：</strong></p>
              <p>每月选用 1 张 10 元叮咚买菜电子券，仅限于在叮咚买菜官方应用购物时，可使用叮咚买菜电子券抵扣付款。</p>
            </li>
            <li>
              <p><strong>天猫超市电子券：</strong></p>
              <p>每月选用 1 张 10 元天猫超市电子券，仅限于天猫超市中网购使用；天猫、淘宝 APP 与电脑端天猫超市支持使用该电子券抵扣付款。</p>
            </li>
            <li>
              <p><strong>京东超市京东E卡：</strong></p>
              <p>每月选用 1 张 10 元京东 E 卡电子券，仅限京东商城 APP/小程序移动端使用；在京东超市购物支付时，可使用京东 E 卡的金额抵扣付款。</p>
            </li>
          </ul>
        </div>
        <div class="equity_body_content_footer">
          <p><strong>注：</strong></p>
          <p>以上锅圈食汇电子券、叮咚买菜电子券、天猫超市电子券、京东E卡、四大权益，每月可任选其一，确定使用本月的一项权益后，剩余的其它三项权益自动失效；下月可重新选择。</p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      regionNo: "",
    };
  },
  created() {},
  mounted() {
    this.init();
  },
  methods: {
    init() {
      const region = localStorage.getItem('regionNo'); // 从 localStorage 获取 region 标识
      if (region) {
        this.regionNo = region;
      } else {
        // 如果没有标识，则可以设置默认值，或请求后端
        console.log('没有找到缓存的 region，使用默认值或请求后端');
        this.regionNo = '31'; // 例如使用 '上海' 作为默认值
      }
    }
  }

};
</script>
<style scoped lang="less">
.equity_layout {
  width: 100%;
  min-height: 100vh;
}
.equity_body {
  width: 100%;
  height: 100%;
  overflow-y: auto;

  .equity_body_content {
    padding: 32px;
    line-height: 1.5;
    color: #333;
    font-size: 14px;
  }
  .equity_body_content_top{
    text-indent: 2em;
  }
  .equity_body_content_middle{
    padding: 16px 0px 16px 32px;
    ul{
      list-style:disc
    }
  }
  .equity_body_content_footer{
    text-indent: 2em;
  }
  h1 {
    font-size: 24px;
    margin-bottom: 16px;
  }
}
</style>
